<template>
    <v-container fluid
                 v-if="!disabled && !disabledTabs">
        <v-row no-gutters>
            <v-col :class="$attrs.hideButtonRowMargin ? '' : 'mt-6'">
                <Button :disabled="disabled || disabledTabs || activeTab === 'AdTagRendering'"
                        icon="mdi-content-save"
                        class="mr-4" @click="$emit('save')"
                        :loading="loading"
                        :color="ada.darkGrey"> Änderungen speichern
                </Button>
                <Button class="mr-4" @click="$emit('deploy:preview')" :color="ada.blue"
                        :loading="$store.state.deploy.deploy_preview_loading"
                        :disabled="disabled || disabledTabs"
                >
                    Deploy: Preview
                </Button>
                <Button @click="$emit('deploy:live')" :color="ada.pink"
                        :disabled="disabled || disabledTabs"
                        :loading="$store.state.deploy.deploy_live_loading">Deploy: Live
                </Button>
                <v-checkbox
                    v-model="deployAll"
                    label="Alle Sitetypes deployen (Live)"
                    class="d-inline-flex mx-4"
                    :color="ada.pink"
                    style="position: relative; top:5px;"
                    width="auto"
                    :false-value="0"
                    :true-value="1"
                ></v-checkbox>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Button from "./buttons/Button";
import ada from "../scss/ada_colors.scss";

export default {
    name: "DeployButtonRow",
    components: {Button},
    props: {
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data: () => {
        return {
            ada,
            deployAll: false,
        }
    },
    computed: {
        readOnly() {
            return this.$store.state.readOnly === 1;
        },
        loading() {
            return this.$store.state.deploy.loading || false;
        },
        activeTab() {
            return this.$store.state.display.activeTab;
        },
        errors() {
            return this.$store.state.errorCount;
        },
        disabledTabs() {
            return this.activeTab === 'Domains' ||
                this.activeTab === 'History';
        }
    },
    watch: {
        deployAll() {
            this.$store.commit('deploy/updateDeployAll', this.deployAll);
        },
        errors() {
            if (this.$store.state.deploy.loading) this.$store.commit('deploy/setLoading', false);
        }
    }
}
</script>

<style scoped>

</style>